import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';

declare const Kakao: any;

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'client';
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    // Kakao SDK는 브라우저 환경에서만 초기화 (SSR에서는 window/document 없음)
    if (
      isPlatformBrowser(this.platformId) &&
      typeof Kakao !== "undefined" &&
      !Kakao.isInitialized()
    ) {
      Kakao.init(environment.kakaoAppKey);
    }
  }
}
